module.exports = __webpack_public_path__ + "static/white-566800df89cedb22bc3c01bdb30bc836.jpg";